<template>
	<div>
		<template v-if="layout === 'new'">
			<div class="new-pagination" v-if="!(links.prev === null && links.next === null)">
				<div class="new-pagination-arrow">
					<a class="arrow-container no-decoration-link"
					   :class="{'has-disabled-link' : links.prev === null}"
					   rel="prev"
					   :title="translations.previous"
					   @click.prevent="links.prev !== null && move(links.prev)">
						<span class="icon"><i class="fa-solid fa-angle-left"></i></span>
					</a>
				</div>

				<template v-for="page in paginate">
					<div class="new-pagination-item" :class="{'has-background-black-bis': page && page.current}">
						<div class="new-pagination-item-container" v-if="page === null">...</div>
						<a v-else :aria-current="page.current ? 'page' : false"
						   class="new-pagination-item-container no-decoration-link"
						   :class="{'has-text-white': page.current}"
						   @click="move(page.url)"
						>
							{{ page.number }}
						</a>
					</div>
				</template>

				<div class="new-pagination-arrow">
					<a class="arrow-container no-decoration-link"
					   :class="{'has-disabled-link' : links.next === null}"
					   rel="next"
					   :title="translations.next"
					   @click.prevent="links.next !== null && move(links.next)">
						<span class="icon"><i class="fa-solid fa-angle-right"></i></span>
					</a>
				</div>
			</div>
		</template>
		<template v-else>
			<nav
				role="navigation"
				aria-label="pagination"
				class="pagination is-centered"
				v-if="!(links.prev === null && links.next === null)"
			>
				<a
					rel="prev"
					:title="translations.previous"
					:data-tooltip="translations.previous"
					class="pagination-previous tooltip"
					:disabled="links.prev === null"
					@click="move(links.prev)"
				>
			<span class="icon">
				<i class="fa-solid fa-angles-left"></i>
			</span>
				</a>
				<a
					rel="next"
					:title="translations.next"
					:data-tooltip="translations.next"
					class="pagination-next tooltip"
					:disabled="links.next === null"
					@click="move(links.next)"
				>
			<span class="icon">
				<i class="fa-solid fa-angles-right"></i>
			</span>
				</a>
				<ul class="pagination-list">
					<li v-for="page in paginate">
						<span v-if="page === null" class="pagination-ellipsis has-text-black">…</span>
						<a
							v-else
							class="pagination-link"
							:aria-current="page.current ? 'page' : false"
							:class="{'is-current': page.current}"
							@click="move(page.url)"
						>
							{{ page.number }}
						</a>
					</li>
				</ul>
			</nav>
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			links: Object,
			meta: Object,
			layout: {
				type: String,
				default: 'default'
			}
		},
		methods: {
			move: function(url)
			{
				if ( !url )
				{
					return;
				}

				this.$emit('move', url);
			}
		},
		computed: {
			paginate: function()
			{
				const currentPage = this.meta.current_page;
				const lastPage = this.meta.last_page;
				const pageFromEnd = lastPage - currentPage;
				const links = this.links;

				let pages = [];

				if (currentPage > 1)
				{
					pages.push({
						current: false,
						url: links.first,
						number: 1,
					});
				}

				if (currentPage > 3)
				{
					pages.push(null);
				}

				if (currentPage > 2)
				{
					pages.push({
						current: false,
						url: links.prev,
						number: currentPage - 1,
					});
				}

				pages.push({
					current: true,
					url: null,
					number: currentPage,
				});

				if (pageFromEnd > 1)
				{
					pages.push({
						current: false,
						url: links.next,
						number: currentPage + 1,
					});
				}

				if (pageFromEnd > 2)
				{
					pages.push(null);
				}

				if (pageFromEnd > 0)
				{
					pages.push({
						current: false,
						url: links.last,
						number: lastPage,
					});
				}

				return pages;
			}
		},
		data: function()
		{
			return { translations: this.$root.translations.pagination };
		}
	}
</script>
